import React from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import EmptyItems from '../../../errors/common/EmptyItems';

const DocumentHistoryFilteredEmptyState = ({ onReset }) => (
  <EmptyItems
    Icon={SearchOutlined}
    title="Aucun résultat pour les critères sélectionnés"
    className="w-full border border-gray-200"
  >
    <p>Essayez de modifier vos filtres, votre recherche ou la période.</p>
    {onReset && (
      <Button
        type="text"
        onClick={onReset}
        className="mt-3 !px-0 text-base text-flexi-primary-color"
      >
        Réinitialiser
      </Button>
    )}
  </EmptyItems>
);

export default DocumentHistoryFilteredEmptyState;
